import { useAppSelector } from '../../../hook/useAppSelector';
import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';

interface Props {
  title: string;
  icon: string;
}

const Header: React.FC<Props> = ({ title, icon }) => {
  const isMobile = useAppSelector((state) => state.configSlice.isMobile);

  return <>{isMobile ? <MobileHeader title={title}></MobileHeader> : <DesktopHeader title={title} icon={icon}></DesktopHeader>}</>;
};

export default Header;
